<template>
    <csp-table
        ref="table"
        :icon="icon"
        :items-ajax-url="itemsAjaxUrl"
        :row-class="rowClass"
        :scrollable="true"
        :table-headline="tableHeadline"
        @row-clicked="onRowClicked"
        @row-contextmenu="onRowContextmenu">
        <template v-slot:above-body>
            <slot name="above-body"/>
        </template>
        <template v-slot:cell(actions)="{ data }">
            <slot
                :data="data"
                name="cell(actions)"/>
        </template>
    </csp-table>
</template>

<script>
    export default {
        name: 'EmailListTable',
        props: {
            icon: {
                default: 'inticon-messages',
                type: String,
            },
            itemsAjaxUrl: {
                required: true,
                type: String,
            },
            tableHeadline: {
                default: 'E-Mails',
                type: String,
            },
            updatingEmailId: {
                default: null,
                type: String,
            },
        },
        emits: ['row-clicked', 'row-contextmenu'],
        methods: {
            loadRecords() {
                this.$refs.table.loadRecords();
            },
            onRowClicked(item) {
                this.$emit('row-clicked', item);
            },
            onRowContextmenu(item, index, event) {
                this.$emit('row-contextmenu', item, index, event);
            },
            rowClass(item) {
                if (!item) {
                    return '';
                }
                const classes = [];
                if (!item.hasBeenRead) {
                    classes.push('font-weight-bold');
                }
                if (this.updatingEmailId !== null && this.updatingEmailId === item.emailId) {
                    classes.push('digital-mailbox-row--updating');
                }
                return classes.join(' ');
            },
            updateRow(emailId, rowData) {
                const tableData = this.$refs.table.records.data;
                const index = tableData.findIndex(row => row.emailId === emailId);
                if (index !== -1) {
                    // Uses splice() to ensure Vue 2 reactivity is triggered correctly
                    tableData.splice(index, 1, rowData);
                }
            },
        },
    };
</script>
